import React, { useState, useEffect } from 'react';

export interface ITextareaInput {
	id?: string;
	placeholder?: string;
	label?: string;
	onChange: (item: string) => void;
	value: number | string;
	defaultValue?: number | string;
	helpText?: string;
	required?: boolean;
	errorMessage?: string;
	cornerHint?: string;
	isDisabled?: boolean;
	className?: string;
	size?: 'normal' | 'small';
	rows?: number;
	cols?: number;
	resize?: boolean;
}

const TextareaInput: React.FC<ITextareaInput> = ({
	label,
	placeholder,
	id,
	value,
	defaultValue,
	onChange,
	helpText,
	required = false,
	errorMessage,
	cornerHint,
	isDisabled = false,
	className = '',
	size = 'normal',
	rows = 2,
	cols = 1,
	resize = true,
}) => {
	const [stateValue, setValue] = useState(value);
	useEffect(() => {
		setValue(value);
	}, [value]);

	const handleOnChange = (val: string) => {
		setValue(val);
		onChange(val);
	};

	const inputBaseStyle = errorMessage
		? 'py-3 block w-full border-red-300 focus:ring-red-500 focus:border-red-500 sm:text-sm rounded-sm text-primary placeholder-red-300 focus:outline-none'
		: 'py-3 block w-full border-gray-300 focus:ring-gray-300 focus:border-gray-300 rounded-sm focus:bg-primary-50 focus:border-primary';

	return (
		<div className={`${className}`}>
			{label && (
				<div className={cornerHint && 'flex justify-between'}>
					<label
						htmlFor={id}
						className="block font-inter text-base font-semibold tracking-normal text-secondary"
					>
						{label} {required && <span className="text-red">*</span>}
					</label>
					{cornerHint && (
						<span className="text-base text-gray-500" id="email-optional">
							{cornerHint}
						</span>
					)}
				</div>
			)}
			<div className={'mt-1 relative rounded-md shadow-sm'}>
				<textarea
					name={id}
					id={id}
					defaultValue={defaultValue}
					value={stateValue}
					disabled={isDisabled}
					onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
						handleOnChange(e.target.value);
					}}
					required={required}
					className={`${inputBaseStyle} ${!resize && 'resize-none'}`}
					placeholder={placeholder}
					rows={rows}
					cols={cols}
				/>
			</div>
			{helpText && (
				<p className="mt-2 text-sm text-gray-500" id={`${id}-description`}>
					{helpText}
				</p>
			)}
			{errorMessage && (
				<p className="mt-2 text-sm text-red-600" id="email-error">
					{errorMessage}
				</p>
			)}
		</div>
	);
};

export default TextareaInput;
